import { API_BASE_URL } from "src/config/api";
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import {
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  CircularProgress,
  Button
} from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../../../components/iconify';

LoginForm.propTypes = {
  setShowLogin: PropTypes.func,
};

function LoginForm({ setShowLogin }) {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ identifier: '', password: '' }); // renamed field
  const [errors, setErrors] = useState({ identifier: '', password: '', message: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.identifier.trim()) {
      newErrors.identifier = 'Email or Username is required';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (event) => {
    event.preventDefault();

    if (validateForm()) {
      const apiUrl = `${API_BASE_URL}/login`;

      const loginData = {
        emailOrUsername: formData.identifier.toLowerCase(),
        password: formData.password,
      };

      setIsLoading(true);

      try {
        const response = await axios.post(apiUrl, loginData);

        if (response.data.success) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('userId', response.data.data._id);
          localStorage.setItem('role', response.data.data.role);

          toast.success(`Welcome ${response.data.data.fullName}`, {
            autoClose: 2000,
          });

          setTimeout(() => {
            window.location.replace('/dashboard');
            if (typeof setShowLogin === 'function') {
              setShowLogin(false);
            }
          }, 1000);
        } else {
          toast.error(response.data.message, {
            autoClose: 2000,
          });
        }
      } catch (errorResponse) {
        console.error(errorResponse);
        if (errorResponse.response && errorResponse.response.data) {
          toast.error(
            <>
              {errorResponse.response?.data?.message || 'An error occurred.'} <a href="/about">Contact Us</a>
            </>
          );
        } else {
          toast.error('Server Not Found.');
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <form onSubmit={handleLogin}>
      <Stack spacing={3}>
        <TextField
          name="identifier"
          label="Email or Username"
          value={formData.identifier}
          onChange={handleInputChange}
          error={!!errors.identifier}
          helperText={errors.identifier}
          fullWidth
          required
          variant="outlined"
          autoComplete="username"
          inputProps={{ 'aria-label': 'Email or Username' }}
        />

        <TextField
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          value={formData.password}
          onChange={handleInputChange}
          error={!!errors.password}
          helperText={errors.password}
          fullWidth
          required
          variant="outlined"
          autoComplete="current-password"
          inputProps={{ 'aria-label': 'Password' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                  aria-label="Toggle password visibility"
                >
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack direction="row" justifyContent="space-between" sx={{ my: 2 }}>
        <Link to="/forgotPassword" underline="hover">
          Forgot password?
        </Link>
      </Stack>

      {errors.message && (
        <Typography variant="body2" color="error" sx={{ mb: 2 }}>
          {errors.message}
        </Typography>
      )}

      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        startIcon={isLoading ? <CircularProgress size={20} style={{ color: 'white' }} /> : null}
        sx={{ justifyContent: 'center', display: 'flex' }}
      >
        {isLoading ? 'Logging in...' : 'Login'}
      </Button>
    </form>
  );
}

export default LoginForm;
